import axios from 'axios'

// 基础API路径 - 确保与后端接口路径匹配
const BASE_URL = '/product-service/api/address'

// 地址相关API方法
const addressApi = {
  /**
   * 获取用户地址列表
   * @param {Number} userId - 用户ID
   * @returns {Promise} - 包含地址列表的响应对象
   */
  getAddressList: (userId) => {
    return axios.get(`${BASE_URL}/list`, {
      params: { userId } // 匹配后端@RequestParam接收方式
    })
  },

  /**
   * 新增收货地址
   * @param {Object} addressData - 地址信息对象
   * @param {String} addressData.receiver - 收货人
   * @param {String} addressData.phone - 联系电话
   * @param {String} addressData.address - 详细地址
   * @param {Number} addressData.userId - 用户ID
   * @param {Number} [addressData.isDefault=0] - 是否默认地址(1-是,0-否)
   * @returns {Promise} - 新增结果响应
   */
  addAddress: (addressData) => {
    return axios.post(`${BASE_URL}/add`, addressData)
  },

  /**
   * 更新收货地址
   * @param {Object} addressData - 地址信息对象(需包含id)
   * @param {Number} addressData.id - 地址ID
   * @param {String} [addressData.receiver] - 收货人
   * @param {String} [addressData.phone] - 联系电话
   * @param {String} [addressData.address] - 详细地址
   * @param {Number} [addressData.isDefault] - 是否默认地址
   * @returns {Promise} - 更新结果响应
   */
  updateAddress: (addressData) => {
    return axios.post(`${BASE_URL}/update`, addressData)
  },

  /**
   * 删除收货地址
   * @param {Number} id - 地址ID
   * @param {Number} userId - 用户ID
   * @returns {Promise} - 删除结果响应
   */
  deleteAddress: (id, userId) => {
    return axios.delete(`${BASE_URL}/delete`, {
      params: { id, userId }
    })
  },

  /**
   * 设置默认地址
   * @param {Number} id - 要设为默认的地址ID
   * @param {Number} userId - 用户ID
   * @returns {Promise} - 设置结果响应
   */
  setDefaultAddress: (id, userId) => {
    return axios.post(`${BASE_URL}/update`, {
      id,
      userId,
      isDefault: 1 // 1表示设为默认地址
    })
  }
}

export default addressApi
    